// extracted by mini-css-extract-plugin
export default {"container":"Card_container__DbXh1","coverImage":"Card_coverImage__AMLPe","favorite":"Card_favorite__mfXCn","link":"Card_link__379CA"};